// Residents store a birthday; the age shown is worked out from it.
export function ageFromBirthdate(birthdate, today = new Date()) {
  if (!birthdate) return null;
  const [year, month, day] = String(birthdate).slice(0, 10).split("-").map(Number);
  if (!year) return null;
  const hadBirthday = today.getMonth() + 1 > month || (today.getMonth() + 1 === month && today.getDate() >= day);
  return today.getFullYear() - year - (hadBirthday ? 0 : 1);
}
